'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = require('_');

var _computeTimezoneGroups = require('../helpers/computeTimezoneGroups');

var _computeTimezoneGroups2 = _interopRequireDefault(_computeTimezoneGroups);

var _TimezoneAliases = require('../lists/TimezoneAliases');

var _TimezoneAliases2 = _interopRequireDefault(_TimezoneAliases);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _.once)(function () {
  var timezoneAliases = (0, _TimezoneAliases2.default)();
  return (0, _computeTimezoneGroups2.default)(timezoneAliases);
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/timezone-utils/static-2.97/js/utils/getTimezoneGroups.js
// module id = 228
// module chunks = 0